module.exports = __webpack_public_path__ + "static/media/texture1cover.b4471654.png";